import { THEME } from "./actionTypes";

export const updateTheme = (payload) => ({
  type: THEME,
  payload,
});
